module.exports = __webpack_public_path__ + "static/img/scheduleWorkItem.1848bd17.png";